import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Chats.module.scss';
import { getTicketIssueTypes } from '../../api';
import IssuesList from './IssuesList';
import { Shimmer } from '../common';
import { getECSFlag, clickTracker } from '../../lib/common';
import FaqRedirectionPage from './FaqRedirectionPage';

export default function TicketCreateNew() {
  const [issuTypesArr, setIssuTypesArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showTicketPopup, setShowTicketPopup] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [showFaq, setShowFaq] = useState(false);
  const selectedIssueRef = useRef('');
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(window.location.search);
  const pageType = queryParams.get('pageType') || '';

  useEffect(() => {
    const handleGetTicketIssueTypes = async () => {
      try {
        setLoading(true);
        const ecsFlag = getECSFlag();
        const resp = await getTicketIssueTypes({ ecsFlag });
        setIssuTypesArr(resp?.errorCode === 0 ? resp?.result?.issueTypesArr || [] : []);
      } catch (err) {
        console.log('Error in getting issue types', err);
      }
      setLoading(false);
    };
    handleGetTicketIssueTypes();
  }, []);

  const openPopupForIssue = (issueVal = '') => {
    selectedIssueRef.current = issueVal;
    setShowTicketPopup(true);
    setConfirmed(false);
    setShowFaq(false);
  };

  useEffect(() => {
    if (!showTicketPopup || !confirmed) return;
    sessionStorage.removeItem('ticketResp');
    const encodedIssueType = encodeURIComponent(selectedIssueRef.current);
    navigate(`/csportal/create_ticket_page?issueType=${encodedIssueType}&pageType=${pageType}`);
  }, [showTicketPopup, confirmed, navigate, pageType]);

  if (loading) {
    return (
      <div className="p-20">
        <Shimmer id="faq" />
      </div>
    );
  }

  if (showFaq) {
    return (
      <div className="p-20">
        <FaqRedirectionPage selectedIssueVal={selectedIssueRef.current} />
      </div>
    );
  }

  return (
    <div className="p-20">
      {!showTicketPopup && (
        <IssuesList issuTypesArr={issuTypesArr} handleRedirectDummyTicketCreate={openPopupForIssue} />
      )}

      {showTicketPopup && (
        <div className={`${styles.ExecutiveBox} mb-20`}>
          <div className={`${styles.TextBox}`}>
            <div className={`${styles.ExecutiveIcon} csicon`} />
            <div className={`${styles.ChatText} font14 fw500 color111`}>
              Are you sure you want a callback for {selectedIssueRef.current}?
              <div className={`${styles.ExecutiveBtnGroup}`}>
                <button
                  type="button"
                  onClick={() => {
                    clickTracker('No', 'Raiseaticket');
                    setShowTicketPopup(false);
                    setShowFaq(true);
                  }}
                  className={`${styles.ExecutiveButton} blue_whitefill_animate`}
                >
                  <div className="font13 fw600 color007">No</div>
                </button>

                <button
                  type="button"
                  onClick={() => {
                    sessionStorage.removeItem('ticketResp');
                    const label = `Issue_${selectedIssueRef.current.replace(/\s+/g, '')}`;
                    clickTracker(label, 'Raiseaticket');
                    const encodedIssueType = encodeURIComponent(selectedIssueRef.current || '');
                    navigate(`/csportal/create_ticket_page?issueType=${encodedIssueType}&pageType=${pageType}`);
                  }}
                  className={`${styles.ExecutiveButton} bluefill_animate`}
                >
                  <div className="font13 fw600 colorFFF">Yes</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
